import React, { useState, useMemo } from "react";
import "./hostScreen.css";
import BottomBar from "../BottomBar";
import { ToastContainer } from "react-toastify";
import { Carousel } from "react-responsive-carousel";
import classNames from "classnames";
import HostDetailsComponent from "./HostDetailsComponent";
import { useDispatch, useSelector } from "react-redux";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { menuActions } from "../../store/menuSlice";
import Experiences from "./Experiences";
import BackFilledSvgIcon from "../../assets/ReactSvg/BackFilledSvgIcon";
import CallIconSvg from "../../assets/ReactSvg/CallIconSvg";
import WhatsappIconSvg from "../../assets/ReactSvg/WhatsappIconSvg";
import ClockIconSvg from "../../assets/ReactSvg/ClockIconSvg";
import "react-responsive-carousel/lib/styles/carousel.min.css";



const HostScreen = ({ currentChefInfo, getStatusLabel }) => {
 

  
};

export default HostScreen;
